import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { LinkedRateCardItem } from "./linked-rate-card-item"

export function SkillMapArchiveMessage({ name, linkedRateCards = [] }) {
    if (linkedRateCards.length === 0) {
        return `Archive "${name}"? It can be restored later from the Archived filter.`
    }
    return (
        <Stack spacing={1}>
            <Typography variant="body1">
                Archive "{name}"? It can be restored later from the Archived filter.
            </Typography>
            <Typography variant="body2" color="warning.main" fontWeight={600}>
                This skill map is used by the following rate {linkedRateCards.length === 1 ? "card" : "cards"}:
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                <Repeat list={linkedRateCards} item={<LinkedRateCardItem />} keyFn={getRateCardId} />
            </Box>
        </Stack>
    )
}

function getRateCardId(rc) {
    return rc.id
}
